<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>Serial Number</v-list-item-title>
            <v-list-item-subtitle>
              {{ hardwareInit.hardware_serial_number }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <tabs class="mt-2" @selectedTab="handleSelectedTab">
          <tab
            title="ข้อมูลทั่วไป"
            class="px-4"
            style="background-color: white"
          >
            <label class="body-2"> เลข Serial Number </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              :value="hardware.hardware_serial_number"
              disabled
              outlined
              dense
            ></v-text-field>
            <label class="body-2">
              รหัส Device
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="1"
              v-model="hardware.hardware_code"
              :rules="[
                (v) => !!v || 'โปรดระบุรหัส Device',
                (v) =>
                  (v && v.length >= 1 && v.length <= 32) ||
                  'รหัส Device ต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
              ]"
              required
              clearable
              @change="checkEmpty($event, 'hardware_code')"
              outlined
              dense
            >
            </v-text-field>
            <label class="body-2">
              ชื่อ Device
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="2"
              v-model="hardware.title_th"
              :rules="[(v) => !!v || 'โปรดระบุชื่อ Device']"
              required
              clearable
              @change="checkEmpty($event, 'title_th')"
              outlined
              dense
            >
            </v-text-field>
            <label class="body-2"> ชื่อ Device (อังกฤษ) </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="3"
              v-model="hardware.title_en"
              clearable
              @change="checkEmpty($event, 'title_en')"
              outlined
              dense
            ></v-text-field>
            <label class="body-2"> ชื่อรุ่น Device </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              :value="hardware.hardware_model_title"
              disabled
              outlined
              dense
            ></v-text-field>
            <label class="body-2"> สถานะ Device </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              :value="hardware.hardware_status_title"
              disabled
              outlined
              dense
            ></v-text-field>
            <div>
              <label class="body-2">พื้นที่</label>
              <v-autocomplete
                class="fix-google-chrome mt-1"
                v-model="hardware.area_uuid"
                :items="areas"
                item-text="title_th"
                item-value="area_uuid"
                outlined
                dense
                clearable
              >
              </v-autocomplete>
            </div>
            <div>
              <v-chip class="mt-4 mb-2">ตั้งค่าคำนวณเวลาทำงาน</v-chip>
              <div>
                <label class="body-2">คำนวณเวลาทำงาน</label>
                <v-select
                  v-model="hardware.is_used_for_work_time_calculation"
                  class="fix-google-chrome mt-1"
                  :items="[
                    { text: 'คำนวณเวลาทำงาน', value: true },
                    { text: 'ไม่คำนวณเวลาทำงาน', value: false },
                  ]"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                ></v-select>
              </div>
            </div>
            <div>
              <v-chip class="my-4">ตั้งค่า Network เพื่อติดต่อ Device</v-chip>
              <div>
                <label class="body-2"> IPv4 </label>
                <v-text-field
                  v-model="hardware.network.ip_v4"
                  class="fix-google-chrome mt-1"
                  :rules="
                    hardware.hardware_model &&
                    [
                      'vf600',
                      'vf1000',
                      'vf1000r',
                      'acu01r',
                      'cru67rc',
                      'cru67rf',
                    ].includes(hardware.hardware_model.hardware_model_code)
                      ? [
                          (v) => !!v || 'โปรดระบุ IP Address',
                          (v) =>
                            !v ||
                            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                              v
                            ) ||
                            'ระบุ IPv4 ไม่ถูกต้อง',
                        ]
                      : [
                          (v) =>
                            !v ||
                            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                              v
                            ) ||
                            'ระบุ IPv4 ไม่ถูกต้อง',
                        ]
                  "
                  clearable
                  outlined
                  dense
                ></v-text-field>
              </div>
              <label class="body-2"> Subnet Mask </label>
              <v-text-field
                v-model="hardware.network.ip_v4_subnet"
                class="fix-google-chrome mt-1"
                :rules="
                  hardware.hardware_model &&
                  [
                    'vf600',
                    'vf1000',
                    'vf1000r',
                    'acu01r',
                    'cru67rc',
                    'cru67rf',
                  ].includes(hardware.hardware_model.hardware_model_code)
                    ? [
                        (v) =>
                          !v ||
                          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                            v
                          ) ||
                          'ระบุ Subnet Mask ไม่ถูกต้อง',
                      ]
                    : [
                        (v) =>
                          !v ||
                          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                            v
                          ) ||
                          'ระบุ Subnet Mask ไม่ถูกต้อง',
                      ]
                "
                clearable
                outlined
                dense
              ></v-text-field>
              <label class="body-2"> Default Gateway </label>
              <v-text-field
                v-model="hardware.network.ip_v4_gateway"
                class="fix-google-chrome mt-1"
                :rules="
                  hardware.hardware_model &&
                  [
                    'vf600',
                    'vf1000',
                    'vf1000r',
                    'acu01r',
                    'cru67rc',
                    'cru67rf',
                  ].includes(hardware.hardware_model.hardware_model_code)
                    ? [
                        (v) =>
                          !v ||
                          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                            v
                          ) ||
                          'ระบุ Default Gateway ไม่ถูกต้อง',
                      ]
                    : [
                        (v) =>
                          !v ||
                          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                            v
                          ) ||
                          'ระบุ Default Gateway ไม่ถูกต้อง',
                      ]
                "
                clearable
                outlined
                dense
              ></v-text-field>
            </div>
          </tab>
          <tab
            title="ติดต่อ Device"
            class="pt-0 px-4"
            style="background-color: white"
          >
            <div
              v-if="
                hardware.hardware_status_title !== 'อยู่ระหว่างซ่อม' &&
                hardware.hardware_model &&
                [
                  'vf600',
                  'vf1000',
                  'vf1000r',
                  'acu01r',
                  'acu81',
                  'acu81r',
                  'tat51i',
                  'cru77rf',
                  'q3rac',
                  'cru67rc',
                  'cru67rf',
                ].includes(hardware.hardware_model.hardware_model_code)
              "
            >
              <v-icon :color="hardware.is_connected ? 'green' : 'red'"
                >mdi-circle-medium
              </v-icon>
              <span
                :class="hardware.is_connected ? 'green--text' : 'red--text'"
              >
                {{ hardware.is_connected ? 'Connect' : 'Disconnect' }}
              </span>
            </div>
            <div
              v-if="hardware.hardware_status_title === 'อยู่ระหว่างซ่อม'"
              class="pa-5"
            >
              {{ hardware.hardware_status_title }}
            </div>
            <div v-else>
              <v-card
                v-if="
                  hardware.hardware_model &&
                  [
                    'vf600',
                    'vf1000',
                    'vf1000r',
                    'acu01r',
                    'acu81',
                    'acu81r',
                    'tat51i',
                    'cru77rf',
                    'q3rac',
                    'cru67rc',
                    'cru67rf',
                  ].includes(hardware.hardware_model.hardware_model_code)
                "
                :disabled="!hardware.is_connected"
                @click="
                  onClickCommand({
                    sync_code: 'get_device_info',
                    title: 'Get Device Info',
                  })
                "
                style="cursor: pointer"
                class="mt-3 pa-2 d-flex justify-space-between"
                outlined
              >
                <div class="d-flex align-center">
                  <span class="pa-3 grey lighten-3 rounded">
                    <v-icon>mdi-text-box-outline</v-icon>
                  </span>
                  <div class="ml-2">Get Device Info</div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
              <v-card
                v-if="
                  hardware.hardware_model &&
                  [
                    'vf600',
                    'vf1000',
                    'vf1000r',
                    'acu01r',
                    'acu81',
                    'acu81r',
                    'tat51i',
                    'cru77rf',
                    'q3rac',
                    'cru67rc',
                    'cru67rf',
                  ].includes(hardware.hardware_model.hardware_model_code)
                "
                :disabled="!hardware.is_connected"
                @click="
                  onClickCommand({
                    sync_code: 'get_employee',
                    title: 'Get Employee Info',
                  })
                "
                style="cursor: pointer"
                class="mt-3 pa-2 d-flex justify-space-between"
                outlined
              >
                <div class="d-flex align-center">
                  <span class="pa-3 grey lighten-3 rounded">
                    <v-icon>mdi-text-box-outline</v-icon>
                  </span>
                  <div class="ml-2">Get Employee Info</div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
              <v-card
                v-if="
                  hardware.hardware_model &&
                  [
                    'vf600',
                    'vf1000',
                    'vf1000r',
                    'acu01r',
                    'acu81',
                    'acu81r',
                    'tat51i',
                    'cru77rf',
                    'q3rac',
                    'cru67rc',
                    'cru67rf',
                  ].includes(hardware.hardware_model.hardware_model_code)
                "
                :disabled="!hardware.is_connected"
                @click="
                  onClickCommand({
                    sync_code: 'get_employee_list',
                    title: 'Get Employee List',
                  })
                "
                style="cursor: pointer"
                class="mt-3 pa-2 d-flex justify-space-between"
                outlined
              >
                <div class="d-flex align-center">
                  <span class="pa-3 grey lighten-3 rounded">
                    <v-icon>mdi-text-box-outline</v-icon>
                  </span>
                  <div class="ml-2">Get Employee List</div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
              <v-card
                v-if="
                  hardware.hardware_model &&
                  [
                    'acu81',
                    'acu81r',
                    'tat51i',
                    'cru77rf',
                    'q3rac',
                    'cru67rc',
                    'cru67rf',
                    'vf1000r',
                    'acu01r',
                  ].includes(hardware.hardware_model.hardware_model_code)
                "
                :disabled="!hardware.is_connected"
                @click="
                  onClickCommand({
                    sync_code: 'get_access_authority_list',
                    title: 'Get Access Authority List',
                  })
                "
                style="cursor: pointer"
                class="mt-3 pa-2 d-flex justify-space-between"
                outlined
              >
                <div class="d-flex align-center">
                  <span class="pa-3 grey lighten-3 rounded">
                    <v-icon>mdi-text-box-outline</v-icon>
                  </span>
                  <div class="ml-2">Get Access Authority List</div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
              <v-card
                v-if="
                  hardware.hardware_model &&
                  [
                    'acu81',
                    'acu81r',
                    'tat51i',
                    'cru77rf',
                    'q3rac',
                    'cru67rc',
                    'cru67rf',
                    'vf1000r',
                    'acu01r',
                  ].includes(hardware.hardware_model.hardware_model_code)
                "
                :disabled="!hardware.is_connected"
                @click="
                  onClickCommand({
                    sync_code: 'set_firmware',
                    title: 'Set Firmware',
                  })
                "
                style="cursor: pointer"
                class="mt-3 pa-2 d-flex justify-space-between"
                outlined
              >
                <div class="d-flex align-center">
                  <span class="pa-3 grey lighten-3 rounded">
                    <v-icon>mdi-text-box-outline</v-icon>
                  </span>
                  <div class="ml-2">Set Firmware</div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
              <v-card
                v-if="
                  hardware.hardware_model &&
                  ['vf1000r', 'acu01r'].includes(
                    hardware.hardware_model.hardware_model_code
                  )
                "
                :disabled="!hardware.is_connected"
                @click="
                  onClickCommand({
                    sync_code: 'get_device_log',
                    title: 'Get Device Log File',
                  })
                "
                style="cursor: pointer"
                class="mt-3 pa-2 d-flex justify-space-between"
                outlined
              >
                <div class="d-flex align-center">
                  <span class="pa-3 grey lighten-3 rounded">
                    <v-icon>mdi-text-box-outline</v-icon>
                  </span>
                  <div class="ml-2">Get Device Log File</div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
              <div
                v-if="
                  hardware.hardware_model &&
                  ![
                    'vf600',
                    'vf1000',
                    'vf1000r',
                    'acu01r',
                    'acu81',
                    'acu81r',
                    'tat51i',
                    'cru77rf',
                    'q3rac',
                    'cru67rc',
                    'cru67rf',
                  ].includes(hardware.hardware_model.hardware_model_code)
                "
                class="pa-5"
              >
                ไม่มีคำสั่ง
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <v-toolbar flat color="blue-grey lighten-4" v-if="selectedTab === 0">
        <v-row justify="center" align="center">
          <v-btn
            :disabled="
              !isHardwareDataChange ||
              (uiCtrl && !uiCtrl.isEnable('btn:::hardware:update'))
            "
            tabindex="4"
            class="primary mr-3"
            depressed
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
          <div class="d-sr-only">{{ isHardwareDataChange }}</div>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog
      v-model="dialogConfirmWorkTimeCalculation"
      persistent
      max-width="580"
    >
      <v-card>
        <v-card-title class="text-h5">
          คุณตั้งค่าคำนวณเวลาทำงานสำหรับ Device
        </v-card-title>
        <v-card-text style="font-size: 16px">
          คุณต้องการให้มีผลการคำนวณเวลาย้อนหลังหรือไม่
          ถ้าต้องการให้มีผลการคำนวณเวลาย้อนหลัง
          กรุณาตั้งค่าวันเริ่มต้นและวันสิ้นสุดของการคำนวณเวลาทำงาน
          <div class="d-flex mt-4">
            <div class="mr-4">
              <label class="body-2">วันเริ่มต้นคำนวณเวลาทำงาน</label>
              <date-picker
                v-model="hardware.work_time_calculation_start_date"
                class="mt-1"
                type="date"
                format="DD/MM/YYYY"
                :disabled-date="disabledAfterDateEnd"
                style="width: 100%"
              ></date-picker>
            </div>
            <div>
              <label class="body-2">วันสิ้นสุดคำนวณเวลาทำงาน</label>
              <date-picker
                v-model="hardware.work_time_calculation_end_date"
                class="mt-1"
                type="date"
                format="DD/MM/YYYY"
                :disabled-date="disabledBeforeDateStart"
                style="width: 100%"
              ></date-picker>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            @click="onConfirmWorkTimeCalculation"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import DatePicker from 'vue2-datepicker'
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'

import 'vue2-datepicker/index.css'

export default {
  components: {
    ConfirmDialog,
    DatePicker,
    Tab,
    Tabs,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    hardware: {
      type: Object,
    },
    hardwareInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogConfirmWorkTimeCalculation: false,
      isSetWorkTimeCalculation: false,
      selectedTab: 0,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isHardwareGeneralDataChange() {
      if (
        this.hardware.hardware_code !== this.hardwareInit.hardware_code ||
        this.hardware.title_th !== this.hardwareInit.title_th ||
        this.hardware.title_en !== this.hardwareInit.title_en
      ) {
        return true
      }
      return false
    },
    isHardwareWorkTimeDataChange() {
      if (
        this.hardware.is_used_for_work_time_calculation !==
        this.hardwareInit.is_used_for_work_time_calculation
      ) {
        return true
      }
      return false
    },
    isHardwareAreaDataChange() {
      if (this.hardware.area_uuid !== this.hardwareInit.area_uuid) {
        return true
      }
      return false
    },
    isHardwareNetworkDataChange() {
      if (
        (this.hardware.network &&
          this.hardware.network.ip_v4 !== this.hardwareInit.network.ip_v4) ||
        (this.hardware.network &&
          this.hardware.network.ip_v4_subnet !==
            this.hardwareInit.network.ip_v4_subnet) ||
        (this.hardware.network &&
          this.hardware.network.ip_v4_gateway !==
            this.hardwareInit.network.ip_v4_gateway)
      ) {
        return true
      }
      return false
    },
    isHardwareDataChange() {
      if (
        this.isHardwareGeneralDataChange ||
        this.isHardwareAreaDataChange ||
        this.isHardwareNetworkDataChange ||
        this.isHardwareWorkTimeDataChange
      ) {
        this.$emit('isHardwareDataChange', true)
        return true
      }
      this.$emit('isHardwareDataChange', false)
      return false
    },
    areas() {
      return this.$store.state.area.areas
    },
  },
  methods: {
    ...mapActions({
      editHardware: 'hardware/editHardware',
      updateNetworkConfig: 'hardware/updateNetworkConfig',
    }),
    onConfirmWorkTimeCalculation() {
      this.isSetWorkTimeCalculation = true
      this.dialogConfirmWorkTimeCalculation = false

      this.onSave()
    },
    disabledAfterDateEnd(date) {
      return date > new Date(this.hardware.work_time_calculation_end_date)
    },
    disabledBeforeDateStart(date) {
      return date < new Date(this.hardware.work_time_calculation_start_date)
    },
    onClickCommand(resource) {
      this.$emit('onClickCommand', resource)
    },
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    checkEmpty(value, field) {
      if (value) {
        this.hardware[field] = value.trim()
      }
    },
    async onSave() {
      if (this.isHardwareWorkTimeDataChange && !this.isSetWorkTimeCalculation) {
        this.dialogConfirmWorkTimeCalculation = true
        return
      }

      if (this.$refs.form.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.$store.state.loading = true

          let callApiList = []

          const hardwareUpdate = {
            ...this.hardwareInit,
            company_uuid,
            hardware_serial_number: this.hardware.hardware_serial_number,
            hardware_status_uuid:
              this.hardware.hardware_status.hardware_status_uuid,
            hardware_uuid: this.hardware.hardware_uuid,
            hardware_code: this.hardware.hardware_code,
            hardware_status_code:
              this.hardware.hardware_status.hardware_status_code,
            title_th: this.hardware.title_th,
            title_en: this.hardware.title_en,
            hardware_model_code:
              this.hardware.hardware_model.hardware_model_code,
            area_uuid: this.hardware.area_uuid || null,
            is_used_for_work_time_calculation:
              this.hardware.is_used_for_work_time_calculation || false,
            work_time_calculation_start_datetime: this.hardware
              .work_time_calculation_start_date
              ? moment(this.hardware.work_time_calculation_start_date)
                  .set({
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0,
                  })
                  .format()
              : null,
            work_time_calculation_end_datetime: this.hardware
              .work_time_calculation_end_date
              ? moment(this.hardware.work_time_calculation_end_date)
                  .set({
                    hour: 23,
                    minute: 59,
                    second: 59,
                    millisecond: 0,
                  })
                  .format()
              : null,
          }

          if (
            this.isHardwareGeneralDataChange ||
            this.isHardwareAreaDataChange ||
            this.isHardwareWorkTimeDataChange
          ) {
            callApiList.push(this.editHardware(hardwareUpdate))
          }

          const payload = {
            company_uuid,
            hardware_model: this.hardware.hardware_model.hardware_model_code,
            body: {
              hardware_uuid: this.hardware.hardware_uuid,
              network: {
                ip_v4: this.hardware.network?.ip_v4 || null,
                ip_v4_subnet: this.hardware.network?.ip_v4_subnet || null,
                ip_v4_gateway: this.hardware.network?.ip_v4_gateway || null,
              },
            },
          }

          if (this.isHardwareNetworkDataChange) {
            callApiList.push(this.updateNetworkConfig(payload))
          }

          if (callApiList.length > 0) {
            await Promise.all(callApiList)
          }

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()

          this.isSetWorkTimeCalculation = false
        } catch (error) {
          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onClose() {
      if (this.isHardwareDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
